export default __webpack_public_path__ + "static/media/checked.16d61e49.svg";